export enum AllowedPLNavRoutes {
  Insured = '/pl-ucm-forms/pl-insured',
  Owner = '/pl-ucm-forms/pl-owner',
  Ratings = '/pl-ucm-forms/pl-ratings',
  Liability = '/pl-ucm-forms/pl-liability',
  ExcessCoverage = '/pl-ucm-forms/pl-excesscoverage',
  Property = '/pl-ucm-forms/pl-property',
  GeneralQuestion = '/pl-ucm-forms/pl-generalquestion',
  CoverageQuestion = '/pl-ucm-forms/pl-coveragequestion',
  Document = '/pollution/underwriting/documents',
  RenewalReview = '/pl-ucm-forms/pl-renewalreview',
  Snapshot = '/pollution/pending-review/policysnapshot',
  PRCoverage = '/pollution/pending-review/verifycoverage',
  PRPolicy = '/pollution/pending-review/verifypolicy',
  VPActionItems = '/pollution/verify-purchase/actionitems',
  VPCoverage = '/pollution/verify-purchase/coverages',
  VPPolicy = '/pollution/verify-purchase/policy'
}

export enum AllowedPLBoundNavRoutes {
  PolicyInfo = '/bound',
  Coverage = '/bound',
  Snapshot = '/bound',
  Declined = '/declined'
}

export enum PLSubmissionRoutes {
  Step1A = AllowedPLNavRoutes.Insured,
  Step1Address = AllowedPLNavRoutes.Insured,
  Step1AUpdate = AllowedPLNavRoutes.Insured,
  Step1B = AllowedPLNavRoutes.Owner,
  Step1BUpdate = AllowedPLNavRoutes.Owner,
  Step1C = AllowedPLNavRoutes.Ratings,
  Step1CUpdate = AllowedPLNavRoutes.Ratings,
  Step2A = AllowedPLNavRoutes.Liability,
  Step2AUpdate = AllowedPLNavRoutes.Liability,
  Step2B = AllowedPLNavRoutes.ExcessCoverage,
  Step2BUpdate = AllowedPLNavRoutes.ExcessCoverage,
  Step2C = AllowedPLNavRoutes.Property,
  Step2CUpdate = AllowedPLNavRoutes.Property,
  Step3A = AllowedPLNavRoutes.GeneralQuestion,
  Step3AUpdate = AllowedPLNavRoutes.GeneralQuestion,
  Step3B = AllowedPLNavRoutes.CoverageQuestion,
  Step3BUpdate = AllowedPLNavRoutes.CoverageQuestion,
  Step3C = AllowedPLNavRoutes.Document,
  Step3CUpdate = AllowedPLNavRoutes.Document,
  Renewal = AllowedPLNavRoutes.RenewalReview,
  RenewalReview = AllowedPLNavRoutes.RenewalReview,
  Step4A = AllowedPLNavRoutes.VPActionItems,
  Step4CompForms = AllowedPLNavRoutes.VPActionItems,
  Step4DwnloadDoc = AllowedPLNavRoutes.VPActionItems,
  Step4InstBill = AllowedPLNavRoutes.VPActionItems,
  Step4InstPaid = AllowedPLNavRoutes.VPActionItems,
  Step4InsurForm = AllowedPLNavRoutes.VPActionItems,
  Step4NewTxn = AllowedPLNavRoutes.VPActionItems,
  Step4PremFin = AllowedPLNavRoutes.VPActionItems,
  Step4Purchase = AllowedPLNavRoutes.VPActionItems,
  Step4Update = AllowedPLNavRoutes.VPActionItems,
  EHelpUWReview = AllowedPLNavRoutes.Snapshot,

  Declined = AllowedPLBoundNavRoutes.Declined,
  'Declined New Business' = AllowedPLBoundNavRoutes.Declined,
  EHelpReviewDoc = AllowedPLBoundNavRoutes.Snapshot,
  InspCreated = AllowedPLBoundNavRoutes.Snapshot,
  InspInfoRequest = AllowedPLBoundNavRoutes.Snapshot,
  InspReview = AllowedPLBoundNavRoutes.Snapshot,
  PolicyBound = AllowedPLBoundNavRoutes.Snapshot,
  StepENAddChange = AllowedPLBoundNavRoutes.Snapshot,
  StepENAIChange = AllowedPLBoundNavRoutes.Snapshot,
  StepENExpChange = AllowedPLBoundNavRoutes.Snapshot,
  InspCompleted = AllowedPLBoundNavRoutes.Snapshot
}
